import { RefreshCw, Send, Copy, Check } from "lucide-react";
import { ChalkActionButton, ChalkCard } from "../primitives";

// Renders the Chalk OS-generated draft + Regenerate / Use this controls.
// Includes a copy-to-clipboard affordance and a stub-mode fallback when the
// AI is unavailable (Use this is disabled, copy is hidden).
export function DraftPreview({
  draft, stub, copied,
  loading, posting,
  onCopy, onRegenerate, onUse,
}) {
  return (
    <ChalkCard data-testid="draw-draft-card" style={{ background: "#FBF8F2" }}>
      <div style={{
        fontSize: 11, textTransform: "uppercase", letterSpacing: "0.08em",
        color: "var(--chalk-muted)", marginBottom: 6,
        display: "flex", justifyContent: "space-between",
      }}>
        <span>{stub ? "AI unavailable" : "Chalk OS draft"}</span>
        {!stub && (
          <button
            type="button"
            data-testid="draw-copy"
            onClick={onCopy}
            style={{
              background: "transparent", border: "none",
              color: "var(--chalk-muted)", fontSize: 11, cursor: "pointer",
              display: "inline-flex", alignItems: "center", gap: 4,
            }}
          >
            {copied ? <Check size={12} aria-hidden="true" /> : <Copy size={12} aria-hidden="true" />}
            {copied ? "Copied" : "Copy"}
          </button>
        )}
      </div>
      <div
        data-testid="draw-draft-text"
        style={{ fontSize: 14, lineHeight: 1.45, color: "var(--chalk-board)", whiteSpace: "pre-wrap" }}
      >
        {draft}
      </div>
      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 8, marginTop: 12 }}>
        <ChalkActionButton
          testId="draw-regenerate"
          variant="ghost"
          label="Regenerate"
          icon={<RefreshCw size={14} aria-hidden="true" />}
          loading={loading}
          onClick={onRegenerate}
        />
        <ChalkActionButton
          testId="draw-use"
          variant="primary"
          label="Use this"
          icon={<Send size={14} aria-hidden="true" />}
          loading={posting}
          disabled={stub}
          onClick={onUse}
        />
      </div>
    </ChalkCard>
  );
}
